import apiClient from './client';
import type {
  CountingSessionResponse,
  CountingAnswerResponse,
} from '../types/counting';

// Session endpoint returns 404 when no problems exist.
// skipRedirectOn404 prevents the axios interceptor from redirecting to the error page,
// allowing components to handle "no problems" gracefully with an inline message.
const skipRedirectOn404Config = { skipRedirectOn404: true } as never;

export const countingApi = {
  startCountingSession: async (): Promise<CountingSessionResponse> => {
    const response = await apiClient.post<CountingSessionResponse>(
      '/counting-practice/session',
      undefined,
      skipRedirectOn404Config
    );
    return response.data;
  },

  /**
   * Get a counting problem by its table result ID (dev-only QA feature).
   * Returns a CountingSessionResponse with a single problem.
   */
  getCountingProblemById: async (tableResultId: number, type?: string): Promise<CountingSessionResponse> => {
    const config = { skipRedirectOn404: true, params: type ? { type } : undefined } as never;
    const response = await apiClient.get<CountingSessionResponse>(
      `/counting-practice/by-id/${tableResultId}`,
      config
    );
    return response.data;
  },

  submitCountingAnswer: async (
    tableResultId: number,
    answer: string,
    // Feature 019: the client scores locally and reports the verdict so the server can record
    // the hand as "seen" for public users (suppresses repeats).
    isCorrect?: boolean
  ): Promise<CountingAnswerResponse> => {
    const response = await apiClient.post<CountingAnswerResponse>(
      `/counting-practice/${tableResultId}/answer`,
      { answer, isCorrect }
    );
    return response.data;
  },

  skipCountingProblem: async (tableResultId: number): Promise<void> => {
    await apiClient.post(`/counting-practice/${tableResultId}/skip`);
  },
};
